export function buildEnrichmentPatchPayload(companyDetails) {
    if (!companyDetails) {
        return {};
    }

    const patch = {};
    if (companyDetails.logo_url) patch.logo_url = companyDetails.logo_url;
    if (companyDetails.description) patch.description = companyDetails.description;
    if (companyDetails.size) patch.company_size = companyDetails.size;
    if (companyDetails.sector) patch.sector = companyDetails.sector;
    else if (companyDetails.industry) patch.sector = companyDetails.industry;
    if (companyDetails.founded) patch.established_year = companyDetails.founded;
    if (companyDetails.url) patch.linkedin = companyDetails.url;
    if (companyDetails.companieshouse) patch.companieshouse = String(companyDetails.companieshouse);
    return patch;
}

export function applyCompanyEnrichment(projectData, companyDetails, fieldMeta = {}) {
    if (!projectData) {
        return projectData;
    }

    const merged = { ...projectData, _fieldMeta: fieldMeta || {} };

    if (companyDetails?.logo_url) merged.logo = companyDetails.logo_url;
    if (companyDetails?.description) merged.description = companyDetails.description;
    if (companyDetails?.size) merged.company_size = companyDetails.size;
    if (companyDetails?.sector) merged.sector = companyDetails.sector;
    else if (companyDetails?.industry) merged.sector = companyDetails.industry;
    if (companyDetails?.founded) merged.established_year = companyDetails.founded;
    if (companyDetails?.url) merged.linkedin = companyDetails.url;
    if (companyDetails?.companieshouse) merged.companieshouse = String(companyDetails.companieshouse);

    return merged;
}
